<div class="wrapper p-4">
    <div class="flex justify-content-between">
        <div class="flex flex-column">
            <h4 class="mb-0">{{ "APPROVAL_CONFIRMATION" | translate }}</h4>
            <span class="text-xs text-500"
                >{{ "APPROVE" | translate }}/{{'REJECT'|translate}} {{'VEHICLES'|translate}}<br />
            </span>
        </div>
        <p-button
            icon="pi pi-times"
            [label]="'CLOSE' | translate"
            (onClick)="closeDialog()"
            severity="danger"
        />
    </div>
    <div>
        <iframe
            *ngIf="blobUrl && mimeType === 'application/pdf'"
            [src]="blobUrl"
            style="width: 100%"
            height="550"
            class="my-4"
        ></iframe>
        <img
            *ngIf="blobUrl && mimeType === 'image/png'"
            [src]="blobUrl"
            style="width: 100%; border: 3px solid gray"
            height="550"
            class="my-4"
            alt="Rendered Blob"
        />
        <img
            *ngIf="blobUrl && mimeType === 'image/jpeg'"
            [src]="blobUrl"
            style="width: 100%; border: 3px solid gray"
            height="550"
            class="my-4"
            alt="Rendered Blob"
        />
    </div>

    <div class="my-3 flex flex-column" [formGroup]="descriptionForm">
        <textarea
            pInputTextarea
            class="w-30rem"
            formControlName="verificationComment"
            [placeholder]="'APPROVAL_REJECTION_EXPLANATION' | translate"
            rows="5"
            cols="30"
        ></textarea>
        <p-checkbox
            class="mt-3"
            #verificationProceedCheckbox
            (onChange)="onCheckboxClicked($event)"
            [binary]="true"
            [label]="'THIS_ACTION_NON_REVERSIBLE' | translate"
        ></p-checkbox>
    </div>
    <hr class="mt-4" />
    <div class="actions-wrapper flex align-items-center gap-2 mt-4">
        <p-button
            icon="pi pi-undo"
            [label]="'CANCEL' | translate"
            (onClick)="closeDialog()"
            severity="secondary"
        />
        <p-button
            icon="pi pi-times-circle"
            [label]="'REJECT' | translate"
            severity="danger"
            [loading]="rejectionLoading"
            (onClick)="rejectClicked()"
            [disabled]="!verificationProceed"
        />
        <p-button
            icon="pi pi-check"
            [label]="'APPROVE' | translate"
            [loading]="approvalLoading"
            (onClick)="approveClicked()"
            severity="success"
            [disabled]="!verificationProceed"
        />
    </div>
</div>
